import React, { useState } from 'react';
import { motion } from 'framer-motion';

export default function BypassPage() {
    const [isPurchasing, setIsPurchasing] = useState(false);
    const [isPurchased, setIsPurchased] = useState(false);

    const handlePurchase = () => {
        if (isPurchased || isPurchasing) return;
        setIsPurchasing(true);
        setTimeout(() => {
            setIsPurchasing(false);
            setIsPurchased(true);
        }, 2000);
    };

    const getExpiryDate = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        return d.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    };
    return (
        <div className="uppercase font-['Monda'] min-h-screen bg-transparent dark:bg-[#0a0a0f] text-gray-900 dark:text-white pt-24 pb-20 selection:bg-pink-500/30 overflow-hidden relative">
            <div className="absolute top-[10%] left-[-10%] w-[40vw] h-[40vw] bg-purple-500/10 dark:bg-purple-600/10 rounded-full blur-[120px] pointer-events-none -z-10 transform translate-z-0"></div>
            <div className="absolute bottom-[10%] right-[-10%] w-[40vw] h-[40vw] bg-pink-500/10 dark:bg-pink-600/10 rounded-full blur-[120px] pointer-events-none -z-10 transform translate-z-0"></div>

            <div className="max-w-[120rem] mx-auto px-4 lg:px-[15px] space-y-[15px]">
                
                {/* Header Section */}
                <div className="relative flex flex-col md:flex-row items-center justify-center gap-4 bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-lg p-6 md:p-[15px] shadow-sm dark:shadow-none min-h-[80px]">
                    <h1 className="text-3xl md:text-5xl font-[AnimetoneFont] uppercase tracking-wider bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-pink-500 text-center">
                        ANIMETONE 1.1.1
                    </h1>
                    <span className="md:absolute md:right-[15px] inline-flex items-center justify-center px-4 py-2 bg-pink-100 dark:bg-pink-500/10 text-pink-600 dark:text-pink-400 border border-pink-200 dark:border-pink-500/20 rounded-md text-sm font-bold tracking-widest uppercase gap-2">
                        <span className="relative flex h-2.5 w-2.5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
                        </span>
                        Latest Release
                    </span>
                </div>

                {/* Main Content Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-[15px]">
                    
                    {/* Left Column: Changelog */}
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="lg:col-span-2 bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-lg p-6 md:p-[25px] shadow-sm dark:shadow-none"
                    >
                        <h2 className="font-['Iceland'] text-3xl font-black uppercase tracking-wider border-b border-gray-200 dark:border-white/10 pb-4 mb-6 text-pink-600 dark:text-pink-400">
                            WHY PLAY BGMI ON PC?
                        </h2>
                        
                        <p className="text-gray-900 dark:text-white font-bold mb-6 text-lg">
                            Ditch the small screen. Elevate your competitive gameplay with keyboard and mouse precision using the safest bypass on the market.
                        </p>

                        <ul className="space-y-6 text-gray-700 dark:text-gray-300 text-sm md:text-base leading-relaxed">
                            <li className="flex gap-4 items-start">
                                <span className="text-2xl mt-0.5">🛡️</span>
                                <div>
                                    <strong className="text-gray-900 dark:text-white block mb-1">100% Anti-Ban Security</strong>
                                    The most secure and undetected bypass engineered specifically to protect your main account. Play aggressively without the fear of bans.
                                </div>
                            </li>
                            <li className="flex gap-4 items-start">
                                <span className="text-2xl mt-0.5">⚡</span>
                                <div>
                                    <strong className="text-gray-900 dark:text-white block mb-1">Always Updated & Maintained</strong>
                                    Game patched? No problem. Animetone is updated within hours of any official BGMI update to ensure zero downtime for our players.
                                </div>
                            </li>
                            <li className="flex gap-4 items-start">
                                <span className="text-2xl mt-0.5">🖥️</span>
                                <div>
                                    <strong className="text-gray-900 dark:text-white block mb-1">Unlock 240 FPS & Ultra HD</strong>
                                    Say goodbye to phone heating, lag spikes, and battery drain. Dominate the lobby with peak PC performance and crystal clear visibility.
                                </div>
                            </li>
                            <li className="flex gap-4 items-start">
                                <span className="text-2xl mt-0.5">🎯</span>
                                <div>
                                    <strong className="text-gray-900 dark:text-white block mb-1">Zero Input Lag</strong>
                                    Experience instant response times. Whether you're tracking enemies or controlling recoil, keyboard and mouse give you an unbeatable competitive edge.
                                </div>
                            </li>
                            <li className="flex gap-4 items-start">
                                <span className="text-2xl mt-0.5">🎮</span>
                                <div>
                                    <strong className="text-gray-900 dark:text-white block mb-1">Seamless Emulator Support</strong>
                                    Fully optimized for top emulators like Gameloop and Mumu (32-bit & 64-bit support rolling out). Just install, activate, and dominate.
                                </div>
                            </li>
                        </ul>
                    </motion.div>

                    {/* Right Column: Sidebar */}
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className="lg:col-span-1 bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border-2 border-gray-200 dark:border-white/10 rounded-lg p-6 md:p-[25px] flex flex-col shadow-lg shadow-black/5 dark:shadow-none"
                    >
                        <h3 className="font-['Iceland'] text-2xl font-black uppercase tracking-wider flex items-center gap-2 border-b border-gray-200 dark:border-white/10 pb-4 mb-6">
                            <span className="text-blue-500">💎</span> PREMIUM ACCESS
                        </h3>

                        <div className="mb-6">
                            <div className="text-4xl font-black text-orange-500 mb-1 tracking-tight">TBA</div>
                            <div className="text-sm text-gray-500 dark:text-gray-400">Validity: until v4.5 release</div>
                        </div>

                        <div className="flex gap-2 mb-8">
                            <span className="flex-1 bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-500/20 py-1.5 px-2 rounded text-xs font-bold uppercase text-center flex items-center justify-center gap-1">
                                ✅ Non-refundable
                            </span>
                            <span className="flex-1 bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-500/20 py-1.5 px-2 rounded text-xs font-bold uppercase text-center flex items-center justify-center gap-1">
                                ✅ Price is fixed
                            </span>
                        </div>

                        <ul className="space-y-4 text-gray-700 dark:text-gray-300 text-sm leading-relaxed mb-8">
                            <li className="flex gap-2">
                                <span className="text-orange-500">▷</span>
                                <span>100% Main ID Safe & Undetected</span>
                            </li>
                            <li className="flex gap-2">
                                <span className="text-orange-500">▷</span>
                                <span>Instant updates after game patches</span>
                            </li>
                            <li className="flex gap-2">
                                <span className="text-orange-500">▷</span>
                                <span>240 FPS Unlocked (Up to Ultra HD)</span>
                            </li>
                            <li className="flex gap-2">
                                <span className="text-orange-500">▷</span>
                                <span>Gameloop & Mumu Support (480p to 4K)</span>
                            </li>
                        </ul>



                        <div className="text-xs text-gray-500 dark:text-gray-400 mb-8 leading-relaxed border-t border-dashed border-gray-300 dark:border-white/20 pt-6">
                            <strong className="text-gray-900 dark:text-white">Activation:</strong> After purchase, you will receive your unique license key. Run the Animetone Installer, enter the key, and you're ready to dominate the lobbies securely.
                        </div>

                        <button 
                            onClick={handlePurchase}
                            disabled={isPurchased || isPurchasing}
                            className={`w-full mt-auto font-black font-['Iceland'] text-xl uppercase tracking-widest py-4 rounded-lg shadow-lg flex items-center justify-center gap-2 transition-colors ${
                                isPurchased
                                    ? 'bg-green-500 text-white shadow-green-500/25 cursor-not-allowed'
                                    : isPurchasing
                                        ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-pink-500/25 cursor-wait'
                                        : 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-pink-500/25'
                            }`}
                        >
                            {isPurchasing ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    PROCESSING...
                                </>
                            ) : isPurchased ? (
                                <>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                                    PURCHASED (EXP: {getExpiryDate()})
                                </>
                            ) : (
                                'GET PREMIUM BYPASS'
                            )}
                        </button>
                    </motion.div>

                </div>
            </div>
        </div>
    );
}
